import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { isDev } from '../constants'

export default function withTracker(WrappedComponent, options = {}) {
  const trackPage = page => {
    if (isDev) return
    ReactGA.set({
      page,
      ...options,
    })
    ReactGA.pageview(page)
  }

  return class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname
      trackPage(page)
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname
      const nextPage = nextProps.location.pathname

      if (currentPage !== nextPage) {
        trackPage(nextPage)
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}
